import { ShoppingBag } from "lucide-react";
import PlaceholderPage from "./PlaceholderPage";

export default function Marketing() {
  return (
    <PlaceholderPage 
      title="Marketing Hub" 
      description="Access marketing tools, templates, and campaigns to promote your travel services to clients."
      icon={<ShoppingBag size={48} />} 
    />
  );
}